import { MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import { Breadcrumb, Button, Col, DatePicker, Form, Input, message, Row, Select, Upload} from 'antd';
import {debounce} from 'lodash';
import dayjs from 'dayjs';
import {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Link, useNavigate} from 'react-router-dom';
import {ReactComponent as Back} from '../../../Images/Back.svg';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import { fetchAlloysList, resetAlloyList } from '../../../slices/alloy';
import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import {createWorkOrder} from '../../../slices/work-order';
import moment from 'moment';

const {Option} = Select;

function CreateSalesOrder() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  useEffect(() => {
    const orderDate = dayjs();
    const purchaseOrderDate = dayjs();
    const deliveryDate = orderDate.clone().add(12, 'days');
    form.setFieldsValue({
      order_date: orderDate,
      delivery_date: deliveryDate,
      purchase_order_date: purchaseOrderDate,
    });
  }, [form]);

  const disablePastDates = current => {
    const currentOrderDate = form.getFieldValue('order_date') || moment();
    return (
      current && current < moment.max(moment().startOf('day'), currentOrderDate)
    );
  };
  const { list: alloyList, loading: alloyLoading } = useSelector(state => state.alloy);
  const { list: temperList, loading: temperLoading } = useSelector(state => state.temper);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);

 
useEffect(() => {
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetJobWorkList());
    dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    dispatch(fetchTempersList({ page: 1, pagesize: 1000 }))
    dispatch(fetchjobWorkList());
  }, [dispatch]);

  const [packingModes, setPackingModes] = useState([
    {title: 'Strech Film', value: 'Strech Film'},
    {title: 'HDPE Packing', value: 'HDPE Packing'},
    {title: 'Inter Leaving', value: 'Inter Leaving'},
    {title: 'Bubble Wrap', value: 'Bubble Wrap'},
    {title: 'Corrugated Box', value: 'Corrugated Box'},
    {title: 'Wooden Box', value: 'Wooden Box'},
    {title: 'Other', value: 'Other'},
  ]);
  

  const handleFinish = async values => {
    

    const updatedWorkOrderDetails = values.work_order_details.map(
      ({wt_kg_p_mt, jobworks, out_source, ...item}) => {
        const detail = {
          ...item,
          pieces: parseFloat(item.pieces) || null,
          min_weight: parseFloat(item.min_weight) || null,
          max_weight: parseFloat(item.max_weight) || null,
          length: parseFloat(item.length) || null,
          nalco_rate: parseFloat(item.nalco_rate) || null,
          jobworks: Array.isArray(jobworks) ? jobworks : [],
          packing_charge: parseFloat(item.packing_charge) || null,
          cutting: item?.cutting || false,
          machinings: item?.machinings || false,
          anodising: item?.anodising || false,
          powder_coating: item?.powder_coating || false,
          pvdf: item?.pvdf || false,
          surface_finish: item.surface_finish,
          modify_nalco_rate: item?.modify_nalco_rate || false,
          net_weight: parseFloat(item.net_weight) || null,
          conversion: item.conversion || null,
        };

        if (jobworks?.includes(4) && out_source != null) {
          detail.out_source = out_source; // out_source should already be boolean (true/false)
        }

        return detail;
      },
    );

    const formattedValues = {
      ...values,
      delivery_date: values.delivery_date.format('YYYY-MM-DD'),
      order_date: dayjs(values.order_date).format('YYYY-MM-DD'),
      purchase_order_date: dayjs(values.purchase_order_date).format(
        'YYYY-MM-DD',
      ),
      work_order_details: updatedWorkOrderDetails,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(formattedValues));
    

    try {
      const result = await dispatch(
        createWorkOrder({values: formData}),
      ).unwrap();
      
      
    } catch (error) {
      

      const messages = [];
      if (typeof error === 'object' && error !== null) {
        for (const key in error) {
          if (Array.isArray(error[key])) {
            messages.push(`${key}: ${error[key].join(', ')}`);
          }
        }
      }
      if (messages.length > 0) {
        message.error(messages.join('; '));
      } else if (typeof error === 'string') {
        message.error(error);
      } else {
        message.error('An unknown error occurred.');
      }
    }
  };




  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Sales Order</h2>
          <div className="bredcrumbwrp">
            <Link to="/sales-order-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                {title: <Link to="/dashboard">Home</Link>},
                {title: <Link to="/sales-order-list">Sales Orders</Link>},
                {title: 'Create Sales Order'},
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          initialValues={{
            customer_name: '',
            order_date: dayjs(),
            purchase_order_date: '',
            purchase_order_no: '',
            packing_type: [],
            project_name: '',
            packing_type_other_reason: '',
            remarks: null,
            po_copy: null,
            sales_order_details: [
              {
                section_no: null,
                alloy: null,
                temper: null,
                length: '',
                net_weight: null,
                pieces: null,
                surface_finish: [],
                cutting: false,
                machinings: false,
                anodising: false,
                powder_coating: false,
                pvdf: false,
                out_source: null,
                anodising_description: '',
                anodising_finishing_price: null,
                powder_coating_description: '',
                powder_coating_finishing_price: null,
                pvdf_description: '',
                pvdf_finishing_price: null,
                machining_price: null,
                cutting_price: null,
                deburring_price: null,
                laser_marking_description: null,
                laser_marking_price: null,
              },
            ],
          }}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="customer_name"
                  label="Customer Name"
                  rules={[{required: true, message: 'Please select customer'}]}
                >
                  <Input placeholder="enter customer name"/>
                </Form.Item>
              </Col>


              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    {required: true, message: 'Please select order date'},
                  ]}
                >
                  <DatePicker
                    style={{width: '100%'}}
                    format="DD-MM-YYYY"
                    defaultValue={moment()}
                    disabled
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_no"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid purchase order no',
                    },
                  ]}
                >
                  <Input placeholder="Enter purchase order no." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    style={{width: '100%'}}
                    format="DD-MM-YYYY"
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={8} xl={6} xxl={4}>
                <Form.Item
                  name="packing_type"
                  label="Mode Of Packing"
                  rules={[
                    {required: true, message: 'Please select mode of packing'},
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={packingModes}
                    mode="multiple"
                  />
                </Form.Item>
                
              </Col>

              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    onChange={e => {
                      const value = e.target.value;

                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                              .toLowerCase()
                              .replace(/\b\w/g, char => char.toUpperCase());

                      form.setFieldsValue({remarks: formattedValue});
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="po_copy"
                  label="Purchase Order Copy"
                  required
                  valuePropName="fileList"
                  
                >
                  <div>
                    <Upload
                      beforeUpload={() => false}
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      showUploadList={{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                      }}
                    >
                      
                        <div
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px 16px',
                            borderRadius: '6px',
                            backgroundColor: ' #FFFBF6',
                            color: 'black',
                            cursor: 'pointer',
                            fontWeight: '500',
                            fontSize: '14px',
                            gap: '8px',
                          }}
                        >
                          <PlusOutlined />
                          <span>Upload</span>
                        </div>
                      
                    </Upload>
                  </div>
                  
                  <label className="filenote">
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="sales_order_details">
              {(fields, {add, remove}) => (
                <>
                  {fields.map(({key, name, ...restField}, index) => (
                    <>
                     
                      <Row
                        gutter={[24, 24]}
                        className="rowItem mx-0"
                        align="middle"
                        key={key}
                        wrap={false}
                        style={{width: '100%'}}
                      >
                        <Col flex="auto">
                          <Row gutter={[16]} key={key}>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'section_no']}
                                label="Section Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select a profile number',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Section No"/>
                              </Form.Item>
                            </Col>
                           
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'alloy']}
                                label="Alloy"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select alloy',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Alloy"
                                  loading={alloyLoading}
                                  notFoundContent={
                                    alloyLoading ? 'Loading...' : 'No options'
                                  }
                                  value={
                                    form.getFieldValue([
                                      'sales_order_details',
                                      name,
                                      'alloy',
                                    ])
                                      ? {
                                          value: form.getFieldValue([
                                            'sales_order_details',
                                            name,
                                            'alloy',
                                          ]),
                                          label: '',
                                        }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'alloy'],
                                      value,
                                    );
                                    
                                  }}
                                  
                                  allowClear
                                  showSearch={true}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      alloyList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.color_code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'temper']}
                                label="Temper"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select temper',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Temper"
                                  loading={temperLoading}
                                 
                                  value={
                                    form.getFieldValue([
                                      'sales_order_details',
                                      name,
                                      'temper',
                                    ])
                                      ? {
                                          value: form.getFieldValue([
                                            'sales_order_details',
                                            name,
                                            'temper',
                                          ]),
                                          label: '',
                                        }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'temper'],
                                      value,
                                    );
                                    
                                  }}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  
                                  allowClear
                                  showSearch={true}
                                  notFoundContent={
                                    temperLoading ? 'Loading...' : 'No options'
                                  }
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      temperList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>

                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'length']}
                                label="Length (mm)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter length',
                                  },
                                  
                                ]}
                              >
                                <Input
                                  maxLength={6}
                                  placeholder="0"
                                  
                                  style={{width: '100px'}}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'pieces']}
                                label="Pieces"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter pieces',
                                  },
                                  {
                                    pattern: /^[1-9]\d{0,5}$/, // only allows numbers from 1 to 999999
                                    message:
                                      'Please enter pieces greater than 0',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0"
                                 
                                  style={{width: '100px'}}
                                />
                              </Form.Item>
                            </Col>
                            
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'net_weight']}
                                label="Net Weight (kg)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter net weight',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0.0"
                                 
                                  style={{width: '100px'}}
                                />
                              </Form.Item>
                            </Col>
                           
                      
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                label="Surface Finish"
                                name={[name, 'surface_finish']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select jobwork',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Jobwork"
                                  mode="multiple"
                                  value={form.getFieldValue([
                                    'sales_order_details',
                                    name,
                                    'surface_finish',
                                  ])}
                                  allowClear
                                  showSearch
                                  optionFilterProp="children"
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'surface_finish'],
                                      value,
                                    );
                                    
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  ))}
                  <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            
                            add();
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              //loading={btnLoading}
            >
              Create Sales Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default CreateSalesOrder;
